exports = module.exports = require("../../../../../../.config/yarn/global/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-input[data-v-0414f192]{box-shadow:inset 0 -1px rgba(0,0,0,.1)}.title-input input[data-v-0414f192]{border:0;font-size:18px;padding:20px 30px;background-color:transparent;color:var(--brainstorm-fg);width:100%;outline:none}", ""]);

// exports
